import * as React from 'react';

import { DropdownField, IDropdownValue } from '../../../components/dropdownField';

import { EHouseMaterial } from '../../../../../../../json_query';
import { FOfferType } from '../../../../../../../utils/category';

const fullList: IDropdownValue[] = [
  { label: 'Кирпичный', value: EHouseMaterial.Brick },
  { label: 'Деревянный', value: EHouseMaterial.Wood },
  { label: 'Монолитный', value: EHouseMaterial.Monolith },
  { label: 'Панельный', value: EHouseMaterial.Panel },
  { label: 'Блочный', value: EHouseMaterial.Block },
  { label: 'Кирпично-монолитный', value: EHouseMaterial.BrickMonolith },
  { label: 'Сталинский', value: EHouseMaterial.Stalin },
];

const flatNewList: IDropdownValue[] = [
  { label: 'Панельный', value: EHouseMaterial.Panel },
  { label: 'Кирпичный', value: EHouseMaterial.Brick },
  { label: 'Монолитный', value: EHouseMaterial.Monolith },
];

const suburbanList: IDropdownValue[] = [
  { label: 'Кирпичный', value: EHouseMaterial.Brick },
  { label: 'Деревянный', value: EHouseMaterial.Wood },
  { label: 'Монолитный', value: EHouseMaterial.Monolith },
  { label: 'Щитовой', value: EHouseMaterial.Shield },
  { label: 'Каркасный', value: EHouseMaterial.Wireframe },
  { label: 'Газобетонный блок', value: EHouseMaterial.AerocreteBlock },
  { label: 'Газосиликатный блок', value: EHouseMaterial.GasSilicateBlock },
  { label: 'Пенобетонный блок', value: EHouseMaterial.FoamConcreteBlock },
];

/* istanbul ignore next */
const getMaterialsList = (offerType: FOfferType) =>
  (offerType === FOfferType.FlatNew && flatNewList) ||
  ((offerType & FOfferType.Suburban & ~FOfferType.Land) !== 0 && suburbanList) ||
  fullList;

export interface IHouseMaterialsProps {
  value: EHouseMaterial[];
  offerType: FOfferType;
  onChange(value: EHouseMaterial[]): void;
}

export const HouseMaterial: React.StatelessComponent<IHouseMaterialsProps> = props => {
  const getValue = () => {
    const { value } = props;
    const result = [];

    if (value && value.length) {
      result.push(...value);
    }

    return result;
  };

  return (
    <DropdownField
      multiple
      placeholder="Любой"
      value={getValue()}
      onValueChange={props.onChange}
      values={getMaterialsList(props.offerType)}
    />
  );
};
